export default __webpack_public_path__ + "static/media/retrofb.4d4ac83e.gif";